import axios from 'axios';
import root from 'window-or-global';

import VideoRecapActions from '../actions/VideoRecapActions';
import Url from '../constants/Url';

/**
 * Idomoo apis
 * Ajax calls for generating custom videos.
 *
 */

const IdomooSource = {
  getContent: {
    remote(state, locale) {
      return axios.get(`${Url().IDOMOO.API(locale)}`);
    },
    success: VideoRecapActions.getContentSuccess,
    error: VideoRecapActions.getContentFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
  generateVideo: {
    remote(state, data, locale) {
      return axios.post(`${Url().IDOMOO.API(locale)}`, data);
    },
    success: VideoRecapActions.generateVideoSuccess,
    error: VideoRecapActions.generateVideoFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default IdomooSource;
